// extracted by mini-css-extract-plugin
module.exports = {"collapse":"PromotionTerms_collapse__1RKPX","collapseTitle":"PromotionTerms_collapseTitle__1UcwN","collapseDescription":"PromotionTerms_collapseDescription__3kd6D"};